import request from '@/utils/request'
import URL from '../urlTranslator'

// 获取放单状态日志，每个状态显示有限制：以"取回"为例，如果存在2条记录，那么最近的一条显示"二次取回"，一次类推
export function queryStatusByBusinessDataId(params) {
  return request({
    url: URL.seaExport.queryStatusByBusinessDataId,
    method: 'get',
    params
  })
}

// 保存状态修改记录
export function saveStatusChangeHistory(data) {
  return request({
    url: URL.seaExport.saveStatusChangeHistory,
    method: 'post',
    data
  })
}
